<ng-container *ngIf="fields$ | async as fields">
  <jml-lib-fields-view
    [fields]="fields"
    [refreshTrigger]="refreshTrigger"
    [rowData]="entityData"
    [dtoType]="dtoType"
    (finishCellEdit)="updateField($event.field, $event.value)"
    (DEPRECATED_finishCellEdit)="completeCellEdit($event)"
  >
  </jml-lib-fields-view>
</ng-container>
